import { MonthlyFuelBudgetStateTypes, MonthlyFuelBudgetActionTypes } from "./MonthlyFuelBudget.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: MonthlyFuelBudgetStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const MonthlyFuelBudgetReducer = (
  state: MonthlyFuelBudgetStateTypes = INITIAL_STATE,
  action: any
): MonthlyFuelBudgetStateTypes => {
  switch (action.type) {
    case MonthlyFuelBudgetActionTypes.FETCH_ALL_MONTHLY_FUEL_BUDGET:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case MonthlyFuelBudgetActionTypes.FETCH_ALL_MONTHLY_FUEL_BUDGET_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case MonthlyFuelBudgetActionTypes.FETCH_ALL_MONTHLY_FUEL_BUDGET_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case MonthlyFuelBudgetActionTypes.FETCH_ALL_MONTHLY_FUEL_BUDGET_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case MonthlyFuelBudgetActionTypes.FETCH_ONE_MONTHLY_FUEL_BUDGET:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case MonthlyFuelBudgetActionTypes.FETCH_ONE_MONTHLY_FUEL_BUDGET_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case MonthlyFuelBudgetActionTypes.FETCH_ONE_MONTHLY_FUEL_BUDGET_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case MonthlyFuelBudgetActionTypes.FETCH_ONE_MONTHLY_FUEL_BUDGET_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default MonthlyFuelBudgetReducer;
